module.exports = __webpack_public_path__ + "img/icon-component-label_PointsAsset.7ab9f703.svg";